import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getItemCodeSummary } from '../../../api/inventory/get_item-code-summary'

/* Initial state of the slice */
const initialState = {
  isFetchingItemCodeSummary: false,
  itemCodeSummary: [],
  fetchItemCodeSummaryError: null,
}

/* Handler for making service call to fetch tags for a specific item */
export const fetchItemCodeSummary = createAsyncThunk(
  'itemCode/fetchItemCodeSummary',
  async (args, { getState, rejectWithValue }) => {
    const state = getState()
    const request = {
      itemNumber: state.inventory.selectedInventoryItem.itemNumber.replaceAll('#', '%23'),
    }
    try {
      const response = await getItemCodeSummary(request)
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const itemCodeSlice = createSlice({
  name: 'itemCode',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemCodeSummary.pending, (state) => {
        state.isFetchingItemCodeSummary = true
        state.itemCodeSummary = []
        state.fetchItemCodeSummaryError = null
      })
      .addCase(fetchItemCodeSummary.fulfilled, (state, action) => {
        state.isFetchingItemCodeSummary = false
        state.itemCodeSummary = action.payload
      })
      .addCase(fetchItemCodeSummary.rejected, (state, action) => {
        state.isFetchingItemCodeSummary = false
        state.fetchItemCodeSummaryError = action.payload
      })
      /* When fetching inventory items is in progress, reset item codes */
      .addCase('inventory/fetchInventoryItems/pending', (state) => {
        state.itemCodeSummary = []
      })
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export default itemCodeSlice.reducer
